export function isNumberRangeValue(data) {
    return typeof data === 'object' && !!data && ('start' in data || 'end' in data);
}
//# sourceMappingURL=NumberRangeValue.js.map